/**
 * ColorStyleEnum can be used to access
 * color style literal values.
 * The values are "auto", "none", "flat",
 * "interp" and "texturemap".
 *
 * @module mw-colorpicker/ColorStyleEnum
 *
 * @example <caption>ColorStyleEnum</caption>
 * var colorPickerDropDown = new ColorPickerDropDown({
 *     colorStyles: [ColorStyleEnum.NONE]
 * });
 *
 * @copyright Copyright 2020 MathWorks, Inc.
 */
define([
], function () {
    const COLORSTYLEENUM = Object.freeze({
        AUTO: 'auto',
        NONE: 'none',
        FLAT: 'flat',
        INTERP: 'interp',
        TEXTUREMAP: 'texturemap'
    });

    return COLORSTYLEENUM;
});
